import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

class CollapsingContainer extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showAll: false,
      childContainerHeight: 0
    };

    this.childContainer = null;
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount () {
    const childContainerHeight = _.get(this, 'childContainer.scrollHeight');
    this.setState({ childContainerHeight });
  }

  handleClick (e) {
    e.preventDefault();
    const { collapsedHeight } = this.props;
    const content = e.currentTarget.parentElement.parentElement.previousElementSibling;
    const collapsedHeightPx = collapsedHeight + 'px';

    if (collapsedHeightPx === content.style.maxHeight) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = collapsedHeightPx;
    }

    this.setState({
      showAll: !this.state.showAll
    });
  }

  render () {
    const { showAll, childContainerHeight } = this.state;

    const {
      collapsedHeight,
      children,
      hasFade,
      showText = this.props.intl.formatMessage({ id: 'invite.collapsing_container.show_all', defaultMessage: 'Show all' }),
      hideText = this.props.intl.formatMessage({ id: 'invite.collapsing_container.show_less', defaultMessage: 'Show less' }),
      className = '',
      animated = true,
      grayBackground = false
    } = this.props;

    const showCollapseButtons = childContainerHeight > collapsedHeight;

    const styles = {
      maxHeight: collapsedHeight + 'px'
    };

    return (
      <div className={classnames('show-all-container', { collapsed: !showAll, animated, 'gray-background rounded-border': grayBackground })}>
        <div
          className={classnames('content', className, { 'show-content': showAll })}
          style={styles}
          ref={ (ref) => { this.childContainer = ref; } }
        >
          {children}
        </div>

        { showCollapseButtons &&
          <div className="group-bottom">
            { !!hasFade && <div className="faded" /> }

            <div className={classnames('button-box', { 'hide-button': showAll })}>
              <button onClick={this.handleClick} type="button"> { showAll ? hideText : showText}</button>
            </div>
          </div>
        }
      </div>
    );
  }
}

CollapsingContainer.propTypes = {
  collapsedHeight: PropTypes.number,
  children: PropTypes.node,
  hasFade: PropTypes.bool,
  showText: PropTypes.string,
  hideText: PropTypes.string,
  className: PropTypes.string,
  animated: PropTypes.bool,
  grayBackground: PropTypes.bool
};

exports.CollapsingContainer = injectIntl(CollapsingContainer);
